<div class="modal__header">
	<div class="modal__header-actions header-actions--mobile">
		<button [attr.aria-label]="'bookingSearch.aria.closeDialog' | ibeadmin | async" (click)="closeModal()">
			<app-svg svg="icons.svg#general--arrow--left-no_margin" aria-hidden="true" [alt]="'bookingSearch.alt.arrowLeftIcon' | ibeadmin | async"></app-svg>
		</button>
	</div>
	<div class="title_wrapper">
		<h2 class="title" id="modal__title">Points of interest</h2>
	</div>
	<div class="modal__header-actions header-actions">
		<button aria-label="'bookingSearch.aria.closeDialog' | ibeadmin | async" (click)="closeModal()">
			<app-svg svg="icons.svg#general--close" aria-hidden="true" [alt]="'bookingSearch.alt.closeIcon' | ibeadmin | async"></app-svg>
		</button>
	</div>
	
	<div class="modal__header-counter-wrapper hidden-tablet-up" *ngIf="selectedThemes.length > 0">
		<span class="modal__header-counter">{{selectedThemes.length}}</span>
	</div>
</div>

<div class="modal__body select-themes-body sl--scrollable">
	<ul class="themes-wrapper">
		<li class="item__theme" *ngFor="let theme of themes; let index = index" (click)="INDRA_handleSelectThemeClick(index)">
			<div class="item__theme-left">
				<app-svg class="item__theme-icon" svg="icons.svg#{{theme.icon}}" aria-hidden="true" [alt]="theme.label + 'bookingSearch.alt.icon' | ibeadmin | async"></app-svg>
				<span class="item__theme-label">{{theme.label}}</span>
			</div>
			<div class="item__theme-right">
				<!-- <app-checkbox-input [label]="theme.label" [attr.id]="'theme-checkbox--' + theme.id" [hideLabel]="true" [checked]="INDRA_isChecked(theme.label)"></app-checkbox-input> -->
				<label class="checkbox-wrapper" [attr.aria-checked]="INDRA_isChecked(theme.label)" [attr.for]="'theme-checkbox--' + theme.id">
					<input [value]="INDRA_isChecked(theme.label)" [attr.id]="'theme-checkbox--' + theme.id" [attr.checked]="INDRA_isChecked(theme.label) ? true : null" type="checkbox" autocomplete="false" class="checkbox">
					<span><label class="visuallyhidden" [attr.for]="'theme-checkbox--' + theme.id">{{theme.label}}</label></span>
				</label>
			</div>
		</li>
	</ul>
</div>

<div class="modal__footer" *ngIf="hasChanges || selectedThemes.length > 0">
	<div *ngIf="hasChanges" class="modal__footer-action"><button (click)="INDRA_handleConfirmationClick()" class="button button--small">Confirm selection</button></div>
	<div *ngIf="selectedThemes.length > 0" class="modal__footer-action align-center"><button (click)="INDRA_handleResetClick()" class="link">Reset selection</button></div>
</div>
